










































// vendor
import { defineComponent, ref, computed } from "@vue/composition-api";
// project
// ---
// local
import { default as OpsSettings } from "./ops-settings.vue";
import { default as SessionSettings } from "./session-settings.vue";
import { default as InfoTooltip } from "./info-tooltip.vue";

export default defineComponent({
	components: {
		OpsSettings,
		SessionSettings,
		InfoTooltip,
	},

	setup(props, context) {

		return {
		};
	},
});
